<template>
  <section>
    <div v-if="descriptionSheets.length">
      <div
        v-for="description in descriptionSheets"
        :key="description.id"
        @click="viewDetail(description)"
        :class="isSuggestionSheet ? '' : 'text-center mx-auto'"
        class="recommend-card d-flex justify-content-start py-1 mb-2"
      >
        <div class="px-2" style="min-width: 40px">
          <em :class="getDescriptionSheetIcon(description)" width="24" height="24" />
        </div>
        <div class="text-left">
          <div class="type">{{ description.title }}</div>
          <div class="path">
            <em>{{ getCategoryPath(description) }}</em>
          </div>
        </div>
      </div>
    </div>
    <div class="text-left" v-else>{{ $t("no-data") }}</div>
  </section>
</template>

<script>
import descriptionSheet from "@/mixins/descriptionSheet";

export default {
  name: "DescriptionSheet",
  props: ["descriptionSheets", "isSuggestionSheet"],
  mixins: [descriptionSheet],
  methods: {
    viewDetail(description) {
      this.$router.push({
        name: "description-sheet-detail",
        params: {
          id: this.isSuggestionSheet
            ? description.suggestDesSheetId
            : description.id,
        },
      });
    },
  },
};
</script>

<style lang='scss' scoped>
.recommend-card {
  cursor: pointer;
  width: 100%;
  min-width: 350px;
  max-width: 350px;
  border: 1px solid rgba(0, 0, 0, 0.125);
  background: #ffffff;
  .type {
    font-weight: 500;
  }
  .path {
    color: gray;
    white-space: break-spaces;
    overflow-wrap: break-word;
    word-break: break-word;
  }
}
@media (max-width: 576px) {
  .recommend-card {
    max-width: 100%;
    min-width: 100%;
  }
}
</style>
